import React, { useState } from "react";
import { Link } from "react-router-dom";
import Back from "shared/assets/images/svg/back_blue.svg";
import IconMail from "shared/assets/images/svg/mail_outline_green.svg";


import { Column } from "devextreme-react/data-grid";
import useModal from "shared/hooks/useModel";
import InviteByEmail from "./component/inviteByEmail";
import {
  GrantedUserStatus,
  useGrantedUser,
} from "customer/settings/grantedUsers/granted-user.service";
import DxfGrid from "shared/component/dxf-grid/dxf-grid";
import { localize } from "shared/helpers/utils";
import ActionsPanelComponent from "shared/component/dxf-grid/actions-panel.component";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

const GrantedUsers = () => {
  const {t} = useTranslation();
  const { grantedUserSource, deleteUserServer ,resendUserServer} = useGrantedUser();
  const [showInvite, openInvite, closeInvite] = useModal(false);
  const [inviteData,setInviteData] = useState({})

  const deleteUser = (userId) => {
    deleteUserServer.mutate(userId, {
      onSuccess({ response }) {
        if (response) {
          grantedUserSource.load();
          toast.success("Delete Successfully");
        }
      },
    });
  };
  const EditUser = (data) => {
   setInviteData(data)
   openInvite()
  };

  const resendInvitation = (userId) => {
    resendUserServer.mutate(userId, {
      onSuccess({ response,error }) {
        if (response) toast.success("Resent Successfully");
        if(error) toast.error(t('errors.server-error'))
      },
    });
  };

  return (
    <div className="settingHome grantedUsers">
      <div className="container">
        <div className="header">
          <div className="page-name">
            <Link className="linkBack" to="/settings">
              <img src={Back} alt="back" />
            </Link>
            <h1>Granted Users</h1>
          </div>
          <div className="info">
            <button className="btn-border-green" onClick={openInvite}>
              <img src={IconMail} alt="icon" /> Invite By Email
            </button>
          </div>
        </div>

        <hr className="hr mb-0" />

       

        <div className="dataTable">
          <DxfGrid dataSource={grantedUserSource}>
            <Column dataField="contactName" cellRender={(c) => localize(c.value)} />
            <Column dataField="jobDescription" cellRender={(c) => localize(c.value)} />
            <Column dataField="phone" />
            <Column dataField="email" />
            <Column dataField="roleTypeName" cellRender={(c) => c.value} />
            <Column dataField="isActive" cellRender={c => c.value ? 'Active' : 'Inactive'} />
            <Column
              dataField="Actions"
              cellRender={(cell) => (
                <UserActions cell={cell} onDelete={deleteUser} onResend={resendInvitation} onEdit={EditUser} />
              )}
            />
          </DxfGrid>
        </div>


      </div>
      <InviteByEmail
        inviteData={inviteData}
        show={showInvite}
        onHide={()=>{setInviteData({}); closeInvite();}}
      />
    </div>
  );
};

export function UserActions({ cell, onDelete ,onResend,onEdit}) {
  const row = cell.data;
    if(row.statusId === GrantedUserStatus.Current) return null;

  function getActions() {
    if (row.statusId === GrantedUserStatus.Invited)
      return [
        { label: "Resend", action: () => onResend(row.id) },
        {
          label: "Delete",
          action: () => onDelete(row.id),
        },
      ];

    return  [{
      label: "Delete",
      action: () => onDelete(row.id),
    },{label: "Edit" , action:()=> onEdit(row)}]
  }

  return <ActionsPanelComponent actions={getActions()} />;
}

export default GrantedUsers;
